exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._2xEcIS77NPfCOAHP2PZFct_0{width:100%;min-height:80vw;text-align:center;line-height:80vw;color:#888;content:\"viewport-units-buggyfill; min-height: 80vw; line-height: 80vw\"}", "", {"version":3,"sources":["D:/alexlees.github.io/src/pages/Message/NoneRead.vue"],"names":[],"mappings":"AACA,2BAAQ,WAAW,gBAAgB,kBAAkB,iBAAiB,WAAW,uEAAuE,CACvJ","file":"NoneRead.vue","sourcesContent":["\n.center{width:100%;min-height:80vw;text-align:center;line-height:80vw;color:#888;content:\"viewport-units-buggyfill; min-height: 80vw; line-height: 80vw\"\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"center": "_2xEcIS77NPfCOAHP2PZFct_0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0df5d12c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Message/NoneRead.vue
// module id = 362
// module chunks = 13